import React from "react";

import { ThemeProvider } from 'styled-components';
import { theme } from '@cdk-rds/core';

import { IconError } from '@cdk-rds/icons';
import { Dialog } from '@cdk-rds/dialog';
import { Button } from '@cdk-rds/button';

import './ErrorDialog.css';

const ErrorDialog = props => {

    const getTitleComponent = () => {
        return (
            <div className={'negative-title'}>
                <IconError height={44} width={44} />
                <h3>{props.title}</h3>
            </div>
        );
    }

    const getMessageComponent = () => {
        return (
                <div className={'negative-message'}>
                    <span className={'attention'}>Attention!</span>
                    &nbsp;{props.message}
                </div>
                );
    }

    return (
        <ThemeProvider theme={theme}>
            <Dialog isOpen={props.isOpen}
                    title={''}
                    hideHeader={true}
                    id={'error-dialog'}
                    style={{zIndex: '10000'}}>
                <div className={'title'}>
                    {getTitleComponent()}
                </div>
                <div className={'message'}>
                    {getMessageComponent()}
                </div>
                <div className={'footer'}>
                    <div className={'error-dialog-okButton'}>
                        <Button
                            text={'OK'}
                            style={{ margin: '10px 10px 0 10px' }}
                            onClick={props.onOk}>
                        </Button>
                    </div>
                </div>
            </Dialog>
        </ThemeProvider>
    );

}

export default ErrorDialog;